import { Box, Button, Typography } from "@mui/material";
import type React from "react";
import { Link } from "react-router";

interface MenuButtonProps {
	title: React.ReactNode;
	path: string;
}

function MenuButton({ title, path }: MenuButtonProps): React.ReactElement {
	return (
		<Button
			component={Link}
			to={path}
			variant="outlined"
			sx={{
				minWidth: 180,
				minHeight: 60,
				borderColor: "#ccc",
				color: "black",
				textTransform: "none",
				fontSize: "14px",
				fontWeight: "normal",
				lineHeight: 1.4,
				"&:hover": {
					borderColor: "#999",
					backgroundColor: "rgba(0, 0, 0, 0.04)",
				},
			}}
		>
			{title}
		</Button>
	);
}

export function Category(): React.ReactElement {
	return (
		<Box>
			<Box sx={{ maxWidth: 800, mx: "auto", p: 3 }}>
				<Typography variant="h5" component="h1" sx={{ fontWeight: "bold", mb: 3 }}>
					お知らせ
				</Typography>
				<Box sx={{ display: "flex", gap: 2 }}>
					<MenuButton title={<>新規作成</>} path="/informations/new" />
					<MenuButton title={<>配信済みのお知らせ一覧</>} path="/informations" />
				</Box>
			</Box>

			<Box sx={{ maxWidth: 800, mx: "auto", p: 3 }}>
				<Typography variant="h5" component="h1" sx={{ fontWeight: "bold", mb: 3 }}>
					利用規約
				</Typography>
				<Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
					<Box sx={{ display: "flex", gap: 2 }}>
						<MenuButton
							title={
								<>
									Glicoメンバーズ
									<br />
									利用規約
								</>
							}
							path="/terms/glico-members"
						/>
						<MenuButton
							title={
								<>
									こぺ
									<br />
									利用規約
								</>
							}
							path="/terms/app"
						/>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}
